import React, { useState, useEffect, useRef } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { addReportLisitingRequest, deleteAdReport, blockAd } from './redux/adReportDispatcher';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';

function AdReportListingTable() {
  const dispatch = useDispatch();
  const location = useLocation();
  const adReportListing = useSelector(state => state.adReportReducer);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    {
      field: "id",
      headerName: "NO",
      width: 60,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
    },
    { field: "created_at", headerName: "Created At", width: 100 },

    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 150 },
    { field: "reason", headerName: "Reason", width: 150 },
    { field: "comment", headerName: "Comment", width: 200 },
    {
      field: "action",
      headerName: "Action",
      width: 180,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "6px", height: "100%", alignItems: "center" }}>

          <button
            onClick={() => {
              const adId = params.row.ad_id; // Make sure ad_id exists
              window.open(`https://chriskelly.xyz/ads/${adId}`, "_blank");
            }}
            style={{
              backgroundColor: "#1976D2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            View
          </button>



        {
          (params.row?.adData.status||1)!=3?
          
          <button
            onClick={() => handleBlock(params.row)}
            style={{
              backgroundColor: "black",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              minWidth: "40px",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Block
          </button>:  <button
            onClick={()=>{}}
            
            style={{
              backgroundColor: "black",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              minWidth: "40px",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Blocked
          </button>
        }


          <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              minWidth: "40px",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Delete
          </button>


        </div>
      )
    }
  ];








  const handleDelete = (row) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to delete this "${row.reason}" report`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(deleteAdReport(row.id));
      }
    });
  };


  const handleBlock = (row) => {
    Swal.fire({
      title: '',
      html:   `Are you sure?<br>You want to block this Ad` ,
      showCancelButton: true,
      confirmButtonText: 'Yes, Block',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {


         var data = {
            id: row.ad_id,
            status:3,
          };
          dispatch(blockAd(data));

      
      }
    });
  };








  useEffect(() => {
    dispatch(addReportLisitingRequest(page + 1, pageSize));

  }, [page, pageSize, dispatch, location.pathname]);



  return (
    <Paper sx={{ height: "95%", width: '100%' }}>

      <DataGrid
        rows={adReportListing.adReportListing || []}
        columns={columns}
        rowCount={adReportListing.totalAdReport || 0}
        paginationModel={{ page, pageSize }}
        paginationMode="server"
        onPaginationModelChange={({ page, pageSize }) => {
          console.log("pagination----", page, pageSize);
          setPage(page);
          setPageSize(pageSize);
        }}
        pageSizeOptions={[10, 25, 50]}
        loading={adReportListing.loading}
        rowHeight={36}
        disableRowSelectionOnClick
      />
    </Paper>
  );
}

export default AdReportListingTable;
